import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

@Component({
  selector: 'app-swal-custom',
  templateUrl: './swal-custom.component.html',
  styleUrls: ['./swal-custom.component.scss'],
})
export class SwalCustomComponent {
  public isEmpty = true;
  public title = '';
  public icon = '';
  public description = '';
  public buttons = [];

  constructor(
    private matDialogRef: MatDialogRef<SwalCustomComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isEmpty = _isEmpty(data);
    this.title = _get(data, 'title', '');
    this.icon = _get(data, 'icon', '');
    this.description = _get(data, 'description', '');
    this.buttons = _get(data, 'buttons', []);
  }

  methodCallback(method) {
    method(this.matDialogRef);
  }

  close() {
    const buttons = this.buttons;
    let button = null;
    if (buttons.length === 1) {
      button = buttons[0];
    } else if (buttons.length > 1) {
      button = buttons[1];
    }
    if (button) {
      button.method(this.matDialogRef);
    }
  }
}
